var map = {
	"./pinfl__ko__id_doc.png": "fbc1",
	"./pinfl__ko__passport.png": "0360",
	"./pinfl__ru__id_doc.png": "cabd",
	"./pinfl__ru__passport.png": "fa38",
	"./pinfl__uz__id_doc.png": "da4a",
	"./pinfl__uz__passport.png": "7ac5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "06a2";